<dx-select-box #selectBox
               displayExpr="name"
               valueExpr="id"
               [dataSource]="serviceTypes"
               [disabled]="loading"
               [readOnly]="readOnly"
               [showClearButton]="false"
               [value]="selectedItem"
               (selectedItemChange)="onSelectedItemChange($event)">
</dx-select-box>
